import React, { Component } from 'react';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input
} from 'reactstrap';

import TextInput from '../../../shared/components/TextInput';
import Form from '../../../shared/components/Form';
import Button from '../../../shared/components/Button';

import { checkUniquenessOfAgencyName } from '../utils';

class AccountInfo extends Component {
  constructor(){
    super();

    this.state = {
      isSaving:false,
      agencyExists:false,
      validationMessages:{}
    }
  }

  handleSubmit(data){
    this.setState({isSaving:true});

    const validationMessages = {};

    if(!data.name || data.name === ''){
      validationMessages['name'] = 'Name is required';
    }


    if(Object.keys(validationMessages).length > 0){
      this.setState({
        validationMessages:validationMessages,
        isSaving:false
      });
      
      return;
    } else {
      this.setState({validationMessages:{}});

      if(this.props.isCreate){
        this.props.createAgency(data)
          .then((res) => this.handleCreateSuccess(res))
          .catch((err) => this.handleFailure(err));
      } else {
        this.props.updateAgency(this.props.accountId,data)
          .then((res) => this.handleSuccess(res))
          .catch((err) => this.handleFailure(err));
      }

    }
  }



  handleCreateSuccess(res){
    this.setState({isSaving:false});
    this.props.history.push(`/superadmin/accounts/${res.instance.id}/brands`);
  }

  handleSuccess(){
    this.setState({isSaving:false});
  }

  handleFailure(err){
    this.setState({isSaving:false});
  }

  handleCheckIfAccountExists(name){
    const validationMessages = {};

    checkUniquenessOfAgencyName(name.trim())
      .then((res) => {
        if(!!res.id){
          validationMessages['name'] = 'This name is already taken please choose another one';
          this.setState({validationMessages:validationMessages,agencyExists:true});
        } else {
          this.setState({validationMessages:{},agencyExists:false});
        }
      });
  }

  getButtonText(){
    const { name, isCreate } = this.props;
    const { isSaving } = this.state; 

    if(isCreate && isSaving) return 'Creating Account';
    if(isCreate && !isSaving) return 'Create Account';
    if(!isCreate && isSaving) return 'Updating Account';
    if(!isCreate &&!isSaving) return 'Update Account';

    return 'Save Account'
  }

  render(){
    const { name, isCreate } = this.props;
    const { isSaving, validationMessages, agencyExists } = this.state; 


    return (
      <div>
        <Row>
          <Col xs='12' md='6'>
            {isCreate && (
              <div>
                <br />
                <h3>New Account</h3>
                <br />
              </div>
            )}
            <Form onSubmit={(data) => this.handleSubmit(data)}>
              <TextInput
                label='Name'
                name='name'
                defaultValue={name}
                placeholder={'ACME inc'}
                required
                debounce={500}
                onChange={(name) => this.handleCheckIfAccountExists(name)}
                warning={validationMessages['name']}
              />
              <Button 
                disabled={isSaving || agencyExists}
                isSubmit
              >
                {this.getButtonText()}
              </Button>
            </Form>
          </Col>
        </Row>
      </div>
    )
  }
}

export default AccountInfo;



// WEBPACK FOOTER //
// ./src/routes/AccountInfo/components/AccountInfo.js